// Vue 核心
import { createApp } from "vue";
import App from "./App.vue";

// 路由和状态管理
import router from "./router";
import store from "./store";

// UI 框架和样式
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "animate.css";

// 国际化
import i18n from "@/local/i18n";

const app = createApp(App); 

app.use(store).use(router).use(ElementPlus).use(i18n);

// 设置全局属性
app.config.globalProperties.$store = store;

app.mount("#app");
